import Vue from 'vue'
import Router from 'vue-router'
import TagPage from '@/pages/TagPage'
import HomePage from '@/pages/HomePage'
import ShopList from '@/pages/ShopList'
import GoodsList from '@/pages/GoodsList'
import Login from '@/pages/Login'
import UserCenter from '@/pages/UserCenter'
import Search from '@/pages/Search'
import ChooseSchool from '@/pages/ChooseSchool'
import ChooseAddress from '@/pages/ChooseAddress'
import Cart from '@/pages/Cart'
import OrderSettle from '@/pages/OrderSettle'
import AddressList from '@/pages/AddressList'
import AddAddress from '@/pages/AddAddress'
import EditAddress from '@/pages/EditAddress'
import FindBuild from '@/pages/FindBuild'
import OrderList from '@/pages/OrderList'
import OrderDetail from '@/pages/OrderDetail'
import DeviceDetail from '@/pages/DeviceDetail'
import DeliveryDetail from '@/pages/DeliveryDetail'
import MyComment from '@/pages/MyComment'
import MyComplaints from '@/pages/MyComplaints'
import MyCoupons from '@/pages/MyCoupons'
import MyDisableCoupons from '@/pages/MyDisableCoupons'
import SelectCoupon from '@/pages/SelectCoupon'
import CheckComplaints from '@/pages/CheckComplaints'
import OnlineComplaints from '@/pages/OnlineComplaints'
import OnlineComment from '@/pages/OnlineComment'
import OtherDetail from '@/pages/OtherDetail'
import FeedBack from '@/pages/FeedBack'
import Auth from '@/pages/Auth'
import Payment from '@/pages/Payment'
import AliPay from '@/pages/AliPay'
import Map from '@/pages/Map'
import SelfTakeProtocol from '@/pages/SelfTakeProtocol'
import OnlineRefund from '@/pages/OnlineRefund'
import MujiaRoutes from './mujia'
import Reward from '@/pages/Reward'
import RewardList from '@/pages/RewardList'
import OutRemarks from '@/pages/OutRemarks'
import BindPhone from '@/pages/BindPhone'
import QrCode from '@/pages/QrCode'
import SchoolPaySuc from '@/pages/SchoolPaySuc'
import WxWork from '@/pages/wxWork'
import MyScore from '@/pages/myScore'
import ScoreDetail from '@/pages/scoreDetail'
import MemberLevel from '@/pages/MemberLevel'
import ExpDesc from '@/pages/ExpDesc'
// import RestaurantDetail from '@/pages/RestaurantDetail'

import RestaurantDetail from '@/pages/RestaurantDetail'

import PackingFee from '@/pages/packingFee'
import CouponPackage from '@/pages/CouponPackage'
import CouponPackageShopList from '@/pages/CouponPackageShopList'
import CouponPackageRecord from '@/pages/CouponPackageRecord'
import PaySuccess from '@/pages/PaySuccess'
import PaySuccess1 from '@/pages/PaySuccess1'
import PunctualArrive from '@/pages/PunctualArrive'

Vue.use(Router)

let constantRouterMap = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: {
      title: '登录',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/index',
    name: 'TagPage',
    component: TagPage,
    meta: {
      title: '校内订餐',
      keepAlive: true,
      isUseCache: false,
      showTab: true,
    }
  },
  {
    path: '/homepage',
    name: 'HomePage',
    component: HomePage,
    meta: {
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/shoplist',
    name: 'ShopList',
    component: ShopList,
    meta: {
      keepAlive: true,
      isUseCache: false,
      showTab: false,
    }
  },
  {
    path: '/goodslist',
    name: 'GoodsList',
    component: GoodsList,
    meta: {
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/usercenter',
    name: 'UserCenter',
    component: UserCenter,
    meta: {
      title: '我的',
      keepAlive: false,
      showTab: true,
    }
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
    meta: {
      title: '搜索',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/chooseschool',
    name: 'ChooseSchool',
    component: ChooseSchool,
    meta: {
      title: '选择当前位置',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/chooseaddress',
    name: 'ChooseAddress',
    component: ChooseAddress,
    meta: {
      title: '搜索地址',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/cart',
    name: 'Cart',
    component: Cart,
    meta: {
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/ordersettle',
    name: 'OrderSettle',
    component: OrderSettle,
    meta: {
      title: '确认下单',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/addresslist',
    name: 'AddressList',
    component: AddressList,
    meta: {
      title: '我的收货地址',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/addaddress',
    name: 'AddAddress',
    component: AddAddress,
    meta: {
      title: '新增收货地址',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/editaddress',
    name: 'EditAddress',
    component: EditAddress,
    meta: {
      title: '编辑收货地址',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/findbuild',
    name: 'FindBuild',
    component: FindBuild,
    meta: {
      title: '店铺配送范围',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/orderlist',
    name: 'OrderList',
    component: OrderList,
    meta: {
      title: '我的订单',
      keepAlive: true,
      isUseCache: false,
      showTab: true,
    }
  },
  {
    path: '/orderdetail',
    name: 'OrderDetail',
    component: OrderDetail,
    meta: {
      title: '订单详情',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/restaurantDetail',
    name: 'RestaurantDetail',
    component: RestaurantDetail,
    meta: {
      title: '订单详情',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/deviceDetail/:id',
    name: 'DeviceDetail',
    component: DeviceDetail,
    meta: {
      title: '柜子详情',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/deliverydetail',
    name: 'DeliveryDetail',
    component: DeliveryDetail,
    meta: {
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/mycomment',
    name: 'MyComment',
    component: MyComment,
    meta: {
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/mycomplaints',
    name: 'MyComplaints',
    component: MyComplaints,
    meta: {
      title: '我的投诉',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/mycoupons',
    name: 'MyCoupons',
    component: MyCoupons,
    meta: {
      title: '我的优惠券',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/myDisableCoupons',
    name: 'myDisableCoupons',
    component: MyDisableCoupons,
    meta: {
      title: '过期优惠券',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/selectcoupon/:type',
    name: 'SelectCoupon',
    component: SelectCoupon,
    meta: {
      title: '我的优惠券',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/checkcomplaints',
    name: 'CheckComplaints',
    component: CheckComplaints,
    meta: {
      title: '投诉',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/onlinecomplaints',
    name: 'OnlineComplaints',
    component: OnlineComplaints,
    meta: {
      title: '我的订单',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/onlinecomment',
    name: 'OnlineComment',
    component: OnlineComment,
    meta: {
      title: '写点评',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/otherdetail',
    name: 'OtherDetail',
    component: OtherDetail,
    meta: {
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/feedback',
    name: 'FeedBack',
    component: FeedBack,
    meta: {
      title: '投诉结果反馈',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/auth',
    name: 'Auth',
    component: Auth,
    meta: {
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/payment',
    name: 'Payment',
    component: Payment,
    meta: {
      title: '在线支付',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/alipay',
    name: 'alipay',
    component: AliPay,
    meta: {
      title: '支付宝支付',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/map',
    name: 'Map',
    component: Map,
    meta: {
      title: '查看地图',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/selftakeprotocol',
    name: 'SelfTakeProtocol',
    component: SelfTakeProtocol,
    meta: {
      title: '自提协议',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/onlinerefund',
    name: 'OnlineRefund',
    component: OnlineRefund,
    meta: {
      title: '申请退款',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/reward',
    name: 'Reward',
    component: Reward,
    meta: {
      title: '打赏西游侠',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/rewardList',
    name: 'RewardList',
    component: RewardList,
    meta: {
      title: '收到的打赏',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/outRemarks',
    name: 'OutRemarks',
    component: OutRemarks,
    meta: {
      title: '添加备注',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/bindPhone',
    name: 'BindPhone',
    component: BindPhone,
    meta: {
      title: '绑定手机号',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/qrcode',
    name: 'QrCode',
    component: QrCode,
    meta: {
    title: '取餐码',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/schoolPaySuc',
    name: 'SchoolPaySuc',
    component: SchoolPaySuc,
    meta: {
      title: '校园卡支付成功',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/memberLevel',
    name: 'MemberLevel',
    component: MemberLevel,
    meta: {
      title: '会员等级',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/expDesc',
    name: 'ExpDesc',
    component: ExpDesc,
    meta: {
      title: '经验说明',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/wxWork',
    name: 'WxWork',
    component: WxWork,
    meta: {
      title: '提示',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/myScore',
    name: 'MyScore',
    component: MyScore,
    meta: {
      title: '蟠桃大厅',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/scoreDetail',
    name: 'ScoreDetail',
    component: ScoreDetail,
    meta: {
      title: '蟠桃明细',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/packingFee',
    name: 'PackingFee',
    component: PackingFee,
    meta: {
      title: '打包费说明',
      keepAlive: false,
      showTab: false
    }
  },
  {
    path: '/couponPackage/list',
    name: 'CouponPackage',
    component: CouponPackage,
    meta: {
      title: '超值购券',
      keepAlive: false,
      showTab: false
    }
  },
  {
    path: '/couponPackage/shoplist',
    name: 'CouponPackageShopList',
    component: CouponPackageShopList,
    meta: {
      title: '超值购券',
      keepAlive: true,
      showTab: false,
    }
  },
  {
    path: '/couponPackage/record',
    name: 'CouponPackageRecord',
    component: CouponPackageRecord,
    meta: {
      title: '购买记录',
      keepAlive: false,
      showTab: false
    }
  },
  {
    path: '/paySuccess',
    name: 'PaySuccess',
    component: PaySuccess,
    meta: {
      title: '支付成功',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/paySuccess1',
    name: 'PaySuccess1',
    component: PaySuccess1,
    meta: {
      title: '支付成功',
      keepAlive: false,
      showTab: false,
    }
  },
  {
    path: '/punctualArrive',
    name: 'PunctualArrive',
    component: PunctualArrive,
    meta: {
      title: '准时达',
      keepAlive: false,
      showTab: false
    }
  },
]

let routes = constantRouterMap.concat(MujiaRoutes)

export default new Router({
  mode: 'history',
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop
      }
      return { x: 0, y: to.meta.savedPosition || 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js